export enum ModuleType{
    EspTransput,
    LogoTransout,
    S7Transput
  }